









import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { isEmpty } from 'lodash';
import {AxiosInstance} from "axios";

@Component
export default class ClassName extends Vue {

  public esiaLink = '';

  @Inject() $api: AxiosInstance;

  @Prop({ type: Boolean, default: false })
  isGoToAuthPopup: boolean;

  mounted() {
    const { origin } = window.location;
    this.esiaLink = this.isGoToAuthPopup ? '#auth-services' : `${origin}/api/esia/gologin`;
  }

  saveUrl() {
    const { name, params, query } = this.$route;
    if (!isEmpty(params) || !isEmpty(query)) {
      localStorage.setItem('pageUrl', JSON.stringify({ name, params, query }));
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/esialink/Esia.vue